import { render, staticRenderFns } from "./BenchmarkMetrics.vue?vue&type=template&id=b6f2695e&scoped=true&"
import script from "./BenchmarkMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./BenchmarkMetrics.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BenchmarkMetrics.vue?vue&type=style&index=0&id=b6f2695e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f2695e",
  null
  
)

export default component.exports